import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import {
  AccountBalanceOutlined as AccountBalanceOutlinedBase,
  CategoryOutlined as CategoryOutlinedBase,
  InboxOutlined as InboxOutlinedBase,
  ShoppingCartOutlined as ShoppingCartOutlinedBase
} from '@mui/icons-material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    margin: 35px auto 0;
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const SegmentIcon = styled(AccountBalanceOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const FamilyIcon = styled(InboxOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const CategoryIcon = styled(CategoryOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const ProductIcon = styled(ShoppingCartOutlinedBase)`
  display: block;
  height: 15px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15px;

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const Strong = styled('strong')``
